function initGalerieSlider() {
    let swiperGalerie = document.querySelectorAll("[data-indexGallery-swiper]");

    if (typeof (swiperGalerie) != 'undefined' && swiperGalerie != null) {

        swiperGalerie.forEach(el => {
            let swiper4 = new Swiper(el, {
                slidesPerView: 1.2,
                navigation: {
                    nextEl: '[data-swiper-next]',
                    prevEl: '[data-swiper-prev]',
                },
                pagination: {
                    el: '[data-swiper-pagination]',
                    clickable: true,
                },
                spaceBetween: 10,
                loop: true,
                initialSlide: 0,
                centeredSlides: false,
                breakpoints: {
                    550: {
                        slidesPerView: 1.5
                    },
                    800: {
                        slidesPerView: 1.8
                    },
                }
            });
        });
    }
}

initGalerieSlider();
